import { createStore } from 'vuex'

export default createStore({
  state: {
    isMobile: false
  },
  getters: {
  },
  mutations: {
    SET_MOBILE (state, mobile) {
      this.state.isMobile = mobile
    }
  },
  actions: {
  },
  modules: {
  }
})
